"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SkeletonRoot = exports.Root = exports.Inner = exports.EditorialCarouselRoot = exports.CategoriesSection = void 0;
var _mui = require("@ori-ui/mui");
var _editorialComponents = require("@ori/editorial-components");
const Root = exports.Root = (0, _mui.styled)('div')({});
const Inner = exports.Inner = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(10, 0),
        marginBottom: theme.spacing(10),
        '&:last-of-type': {
            paddingBottom: theme.spacing(8)
        },
        [theme.breakpoints.up('sm')]: {
            gap: theme.spacing(14, 0),
            marginBottom: theme.spacing(14)
        }
    };
});
const SkeletonRoot = exports.SkeletonRoot = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        width: '100%',
        margin: '0 auto',
        textAlign: 'center',
        display: 'flex',
        alignSelf: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        gap: theme.spacing(2, 0),
        span: {
            margin: 0,
            padding: 0
        },
        [theme.breakpoints.up('md')]: {
            width: '1306px'
        }
    };
});
const EditorialCarouselRoot = exports.EditorialCarouselRoot = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        maxWidth: '1078px',
        margin: theme.spacing(0, 'auto', 10, 3),
        [theme.breakpoints.up('sm')]: {
            margin: theme.spacing(0, 'auto', 14, 'auto')
        }
    };
});
const CategoriesSection = exports.CategoriesSection = (0, _mui.styled)(_editorialComponents.CategoriesSection)((param)=>{
    let { theme } = param;
    return {
        paddingLeft: theme.spacing(3),
        [theme.breakpoints.up('md')]: {
            paddingLeft: 0
        }
    };
});
